import React, { useEffect } from 'react'
import * as d3 from 'd3'
import { useElementSize } from '../hooks'

export const LineGraph = ({ data }: { data: ILineGraphData[] }) => {
  const [wrapperRef, width, height] = useElementSize()

  useEffect(() => {
    if (!width || !height) { return }

    const svg = d3.select(wrapperRef.current)
    const container = svg.append('g').attr('transform', 'translate(28, 10)')
    const lines = container.selectAll('.line')
    lines.exit().remove()

    const colors = d3.scaleOrdinal<string>().domain(data.map(d => d.label)).range(d3.schemeSet2)
    const xMin = d3.min(data, d => d3.min(d.value, v => v[0])) || 0
    const xMax = d3.max(data, d => d3.max(d.value, v => v[0])) || 0
    const yMin = d3.min(data, d => d3.min(d.value, v => v[1])) || 0
    const yMax = d3.max(data, d => d3.max(d.value, v => v[1])) || 0
    const x = d3.scaleLinear().domain([xMin, xMax]).range([0, width - 30])
    const y = d3.scaleLinear().domain([yMax, yMin]).range([0, height - 30])

    svg.append('g').attr('transform', `translate(28, ${height - 20})`).call(d3.axisBottom(x).ticks(5))
    svg.append('g').attr('transform', 'translate(28, 10)').call(d3.axisLeft(y))

    lines
      .data(data)
      .enter()
      .append('path')
      .attr('fill', 'none')
      .attr('stroke', (d) => colors(d.label))
      .attr('stroke-width', 1.5)
      .attr('d', d => {
        return d3.line()
          .curve(d3.curveCatmullRom)
          .x(dd => x(dd[0]))
          .y(dd => y(dd[1]))
          (d.value)
      })

  }, [data, width, height])

  return <svg ref={wrapperRef} style={{ width: '100%', height: '100%' }} />
}

// const render = async () => {
//   // set the dimensions and margins of the graph
//   const margin = { top: 10, right: 100, bottom: 30, left: 30 },
//     width = 460 - margin.left - margin.right,
//     height = 400 - margin.top - margin.bottom

//   // append the svg object to the body of the page
//   const svg = d3.select(ref.current as any)
//   svg.append('svg')
//     .attr('width', width + margin.left + margin.right)
//     .attr('height', height + margin.top + margin.bottom)
//     .append('g')
//     .attr('transform',
//       'translate(' + margin.left + ',' + margin.top + ')')

//   // Read the data
//   const data: any = await d3.csv('https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/data_connectedscatter.csv')

//   // List of groups (here I have one group per column)
//   const allGroup = ['valueA', 'valueB', 'valueC']

//   // Reformat the data: we need an array of arrays of {x, y} tuples
//   const dataReady = allGroup.map((grpName) => ({ // .map allows to do something for each element of the list
//     name: grpName,
//     values: data.map((d: any) => ({ time: d.time, value: +d[grpName] })),
//   }))
//   // I strongly advise to have a look to dataReady with
//   // console.log(dataReady)

//   // A color scale: one color for each group
//   const myColor = d3.scaleOrdinal()
//     .domain(allGroup)
//     .range(d3.schemeSet2)

//   // Add X axis --> it is a date format
//   const x = d3.scaleLinear()
//     .domain([0,10])
//     .range([ 0, width ])
//   svg.append('g')
//     .attr('transform', 'translate(0,' + height + ')')
//     .call(d3.axisBottom(x))

//   // Add Y axis
//   const y = d3.scaleLinear()
//     .domain( [0,20])
//     .range([ height, 0 ])
//   svg.append('g')
//     .call(d3.axisLeft(y))

//   // Add the lines
//   const line = d3.line()
//     .x(function (d: any) { return x(+d.time) })
//     .y(function (d: any) { return y(+d.value) })
//   svg.selectAll('myLines')
//     .data(dataReady)
//     .enter()
//     .append('path')
//     .attr('d', function (d){ return line(d.values) } )
//     .attr('stroke', ((d: any) => myColor(d.name)) as any)
//     .style('stroke-width', 4)
//     .style('fill', 'none')

//     // Add the points
//   svg
//       // First we need to enter in a group
//     .selectAll('myDots')
//     .data(dataReady)
//     .enter()
//     .append('g')
//     .style('fill', function (d: any){ return myColor(d.name) } as any)
//       // Second we need to enter in the 'values' part of this group
//     .selectAll('myPoints')
//     .data(function (d){ return d.values })
//     .enter()
//     .append('circle')
//     .attr('cx', function (d: any) { return x(d.time) } )
//     .attr('cy', function (d: any) { return y(d.value) } )
//     .attr('r', 5)
//     .attr('stroke', 'white')

//     // Add a legend at the end of each line
//   svg
//     .selectAll('myLabels')
//     .data(dataReady)
//     .enter()
//     .append('g')
//     .append('text')
//     .datum(function (d) { return { name: d.name, value: d.values[d.values.length - 1] } }) // keep only the last value of each time series
//     .attr('transform', function (d) { return 'translate(' + x(d.value.time) + ',' + y(d.value.value) + ')' }) // Put the text at the position of the last point
//     .attr('x', 12) // shift the text a bit more right
//     .text(function (d) { return d.name })
//     .style('fill', (d) => myColor(d.name) as any)
//     .style('font-size', 15)
// }

export interface ILineGraphData {
  label: string
  value: [number, number][]
}
